import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES_MODULES_KEY,
} from '../../common/constants';
import Releases from './Releases';
import ViewRelease from './ViewRelease';
import './release.less';

function ReleasesWrapper() {
  return (
    <Switch>
      <Route
        exact
        path={ROUTES_MODULES_KEY?.RELEASES}
        render={(props) => (
          <AccessControl
            modulekey={MODULES_KEY?.RELEASES}
            allowedPermissions={[PERMISSION_OBJECT?.read]}
            showNoAccess
          >
            <Releases {...props} />
          </AccessControl>
        )}
      />
      <Route
        exact
        path={ROUTES_MODULES_KEY?.VIEW_RELEASE}
        render={(props) => (
          <AccessControl
            modulekey={MODULES_KEY?.RELEASES}
            allowedPermissions={[PERMISSION_OBJECT?.read]}
            showNoAccess
          >
            <ViewRelease {...props} />
          </AccessControl>
        )}
      />
    </Switch>
  );
}

export default ReleasesWrapper;
